export var rule = function rule(_node) {
  return '----';
};